import * as actionTypes from "../constants/actionTypes";
import { SORTS } from "../constants/sorts";

const sort = (
  state = {
    phoneOffer: SORTS.popular,
    proposition: SORTS.bestTco,
    simOnly: SORTS.bestTco
  },
  action
) => {
  switch (action.type) {
    case actionTypes.RESET_SORT:
    case actionTypes.UPDATE_SORT:
      return { ...state, [action.offerType]: action.sort };
    case actionTypes.RESET_SORTS:
      return action.sort;
    default:
      return state;
  }
};

export default sort;
